import { render, staticRenderFns } from "./TabInstallations.vue?vue&type=template&id=2448dc6d&"
import script from "./TabInstallations.vue?vue&type=script&lang=js&"
export * from "./TabInstallations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports